"use strict";

exports.__esModule = true;
//# sourceMappingURL=widgetStatics.js.map